import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { useUser } from "@/hooks/useUser";
import Header from "@/components/Header";
import { verifikatorKepemimpinanNavigations } from "@/constants";

export default function VerifikatorKepemimpinanLayout() {
  const { user, isPending } = useUser();
  const userRoles = user?.jenis_user || [];
  const verifikator =
    userRoles.includes("verifikator_kepemimpinan") ||
    userRoles.includes("verifikator_kepemimpinan_all");

  if (!isPending && !verifikator) return <Navigate to={"/"} />;

  return (
    <main className="flex">
      <Sidebar navigationMenus={verifikatorKepemimpinanNavigations} />
      <section className="flex-1 overflow-x-auto p-5 min-h-screen">
        <Header />
        <Outlet />
      </section>
    </main>
  );
}
